import { render } from "./ColorPalette.vue?vue&type=template&id=3f2b31a7&scoped=true"
import script from "./ColorPalette.vue?vue&type=script&lang=js"
export * from "./ColorPalette.vue?vue&type=script&lang=js"

import "./ColorPalette.vue?vue&type=style&index=0&id=3f2b31a7&scoped=true&lang=css"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2b31a7"]])

export default __exports__